import styled from "styled-components";
import Fonts from "../../../themes/Fonts";

export const Table = styled.table`
  width: ${(props) => props.width || "100%"};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
`;

export const Td = styled.td`
  background-color: ${(props) => props?.backgroundColor || ""};
  border: 1px solid #ccc;
  width: ${(props) => props.width || "auto"};
`;
